export default __webpack_public_path__ + "static/media/KOR.1536d838.svg";